const text = {
  black1: "rgba(0,0,0,0.86)",
  gray1: "rgba(0,0,0,0.56)",
  gray2: "rgba(0,0,0,0.36)",
  gray3: "rgba(0,0,0,0.20)",
  raddishPink1: "#E40046",
  green1: "#00AB59",
  skyBlue1: "#2F80ED",
  orange3: "#F25700",
  white: "#fff",
};

const misc = {
  darkGreen: "#075E54",
  green2: "#00BA6E",
  green3: "rgba(0, 221, 115, 0.1)",
  skyBlue2: "rgba(0, 116, 201, 0.7)",
  softPink2: "rgba(255, 46, 0, 0.1)",
  softPink3: "rgba(235, 174, 59, 0.1)",
  // ^ Looks more like yellow 😐
  gray4: "rgba(0, 0, 0, 0.2)",
  gray5: "rgba(196, 196, 196, 0.33)",
  gray6: "rgba(0, 0, 0, 0.1)",
  gray7: "rgba(0, 0, 0, 0.05)",
  // gray7 & gray8 are the same,
  gray8: "rgba(0, 0, 0, 0.05)",
  gray9: "#F7F7F7",
};

const colors = { ...text, ...misc };

export default colors;
